import { render, staticRenderFns } from "./404.vue?vue&type=template&id=2c1e39a4&scoped=true"
import script from "./404.vue?vue&type=script&setup=true&lang=js"
export * from "./404.vue?vue&type=script&setup=true&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=2c1e39a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e39a4",
  null
  
)

export default component.exports